// https://alligator.io/vuejs/global-event-bus/
import Vue from 'vue';
// export const EventBus = new Vue();
const EventBus = new Vue();

Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function() {
      return EventBus;
    }
  }
});

export default EventBus;



// WEBPACK FOOTER //
// ./src/plugins/EventBus.js